import { useCallback, useState } from 'react';
import * as Cesium from 'cesium';
import type { MapTheme } from '../types';
import { buildMapThemeProvider } from '../utils/mapThemeProvider';

export function useMapTheme(
  viewerRef: React.MutableRefObject<Cesium.Viewer | null>,
  secondaryViewerRef: React.MutableRefObject<Cesium.Viewer | null>,
) {
  const [mapTheme, setMapThemeState] = useState<MapTheme>('dark');

  const setMapTheme = useCallback(async (theme: MapTheme) => {
    const applyToViewer = async (viewer: Cesium.Viewer | null) => {
      if (!viewer || viewer.isDestroyed()) return;
      const provider = await buildMapThemeProvider(theme);
      viewer.imageryLayers.removeAll();
      viewer.imageryLayers.addImageryProvider(provider);
      viewer.scene.requestRender();
    };

    await Promise.all([
      applyToViewer(viewerRef.current),
      applyToViewer(secondaryViewerRef.current),
    ]);
    setMapThemeState(theme);
  }, [buildMapThemeProvider]);

  return {
    mapTheme,
    setMapTheme,
  };
}
